'use client';

import type { MatchSnippet } from 'src/sections/search-all/utils/search-all-match-snippet';

import Box from '@mui/material/Box';

import { RADIUS } from 'src/theme/ui-tokens';

/**
 * 카드가 검색어에 걸린 이유 한 줄의 **글자** — 감싸는 줄(글자 크기 · 줄 수)은 부르는 쪽이 정한다.
 *
 * ```
 *   text   앞 조각 + 칠한 검색어(옅은 노랑 · 굵게) + 뒤 조각
 *   name   「작성자명 · {이름}」
 *   lead   글머리 그대로
 *   null   「본문 밖에서 찾음 — 확장 검색·AI 판별」
 * ```
 * 🔑 컨텐츠 허브(소재 찾기 · `media-grid`)와 한 번에 찾기 결과 사진 줄이 같은 부품을 쓴다 — 칠하는 모양이 화면마다 갈리지 않는다.
 */
export function MatchSnippetText({ snippet }: { snippet: MatchSnippet | null }) {
  if (snippet === null) return <>본문 밖에서 찾음 — 확장 검색·AI 판별</>;
  if (snippet.kind === 'name') return <>작성자명 · <Box component="b" sx={{ color: 'text.primary' }}>{snippet.name}</Box></>;
  if (snippet.kind === 'lead') return <>{snippet.text}</>;
  return (
    <>
      {snippet.before}
      <Box component="mark" sx={{ bgcolor: 'warning.lighter', color: 'text.primary', fontWeight: 600, px: 0.25, borderRadius: RADIUS.sm }}>{snippet.hit}</Box>
      {snippet.after}
    </>
  );
}

/** 조각 전체 글자 — 줄이 잘릴 때 마우스를 올리면 보이는 `title` */
export function matchSnippetTitle(snippet: MatchSnippet | null | undefined): string | undefined {
  if (snippet?.kind === 'text') return `${snippet.before}${snippet.hit}${snippet.after}`;
  if (snippet?.kind === 'lead') return snippet.text;
  return undefined;
}
